
const items = {
  items: [
    {
      id: 'dashboard',
      title: 'Dashboard',
      type: 'group',
      children: [
        {
          id: 'dashboard',
          title: 'Dashboard',
          type: 'item',
          url: '/',
          subUrl:[]
        }
      ]
    },
    {
      id: 'mapping',
      title: 'Mapping',
      type: 'group',
      children: [
        {
          id: 'upload-mapping-file',
          title: 'Upload Mapping File',
          type: 'item',
          url: '/mapping/upload',
          subUrl:[]
        },
        {
          id: 'download-mapping-file',
          title: 'Download Mapping File',
          type: 'item',
          url: '/mapping/download',
          subUrl:[]
        },
        {
          id: 'master-mapping-data',
          title: 'Master Mapping Data',
          type: 'item',
          url: '/parameters',
          subUrl:[
            '/connections',
            '/events',
            '/events/edit',
            '/modbus',
            '/can/constant-messages',
            '/can/constant-messages/new',
            '/can/definitions',
            '/can/definitions/new',
            '/can/request-pgn',
            '/can/receive-messages',
            '/can/receive-messages/new',
            '/can/receive-messages/edit',
            '/can/transmit-messages',
            '/can/transmit-messages/new',
            '/st-homepage'
          ]
        }
      ]
    },
    {
      id: 'config',
      title: 'Config',
      type: 'group',
      children: [
        {
          id: 'config-add-new-project',
          title: 'Add New Project',
          type: 'item',
          url: '/config/add-project',
          subUrl:[]
        },
        // {
        //   id: 'download-config-file',
        //   title: 'Download Config File',
        //   type: 'item'
        // },
        {
          id: 'projects-list',
          title: 'Projects List',
          type: 'item',
          url: '/config/projects-list',
          subUrl:[]
        }
      ]
    },
    {
      id: 'generate',
      title: 'Generate',
      type: 'group',
      children: [
        {
          id: 'generate-config-file',
          title: 'Generate Config File',
          type: 'item',
          url: '/generate-config',
          subUrl:[]
        }
      ]
    },
    // {
    //   id: 'update',
    //   title: 'Update',
    //   type: 'group',
    //   children: [
    //     {
    //       id: 'update-data',
    //       title: 'Update Data',
    //       type: 'item',
    //       url: '/parameters'
    //     }
    //   ]
    // },
    {
      id: 'view',
      title: 'View',
      type: 'group',
      children: [
        {
          id: 'view-configurations',
          title: 'View Configurations',
          type: 'item',
          url : '/mapping/parameters',
          subUrl:[
            '/mapping/connections',
            '/mapping/events',
            '/mapping/modbus',
            '/mapping/can/constant-messages',
            '/mapping/can/constant-messages/new',
            '/mapping/can/definitions',
            '/mapping/can/definitions/new',
            '/mapping/can/request-pgn',
            '/mapping/can/receive-messages',
            '/mapping/can/transmit-messages',
            '/mapping/can/transmit-messages/new',
            '/mapping/homepage'
          ]
        },
        {
          id: 'view-json-mappings',
          title: 'Configuration Validator',
          type: 'item',
          url : '/view/json-mappings',
          subUrl:[]
        }
      ]
    },
    {
      id: 'help',
      title: 'Help',
      type: 'group',
      children: [
        {
          id: 'help',
          title: 'Feedback and Help Request',
          type: 'item',
          url: '/help',
          subUrl:[]
        }
      ]
    },
  ]
};

export default items;

